import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import PageConH5 from '@/componentsH5/productSmart/smartDevices';
import PageConPc from '@/components/productSmart/smartDevices';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import getCanEnterFlag from '@/utils/getCanEnterFlag';

export default function Page({ SEO }: any) {
    const { isMobile, useRouter, useLang } = useGlobal();
    const router = useRouter();
    const [theme, setTheme] = useState('black');
    const { t } = useLang('smartdevices');
    const { locale } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const { flag1, flag2, flag3 } = getCanEnterFlag(router?.query?.cid); // 提前打开4-26号
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es']} locale={locale} pathname="smart-devices-teaser" />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon ecoflowflag={flag1} ecoflowflag2={flag2} ecoflowflag3={flag3} />
                </div>
            </PageLayout>
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}
